import { Render, Data } from '@measured/puck';

import { createConfig } from '../config/puck.config';
import { ContentPageMetadata } from '../types';

type IPuckRenderProps = {
  readonly reportDefinition: Data;
  readonly metadata: ContentPageMetadata;
};

function PuckRender({ metadata, reportDefinition }: IPuckRenderProps) {
  const config = createConfig({ metadata });
  return <Render config={config} data={reportDefinition} metadata={metadata} />;
}

export { type IPuckRenderProps, PuckRender as Render };
